import { useBrand } from "@/contexts/BrandContext";
import { BrandLandingPresentation } from "@/components/brand/BrandLandingPresentation";

export default function WhiteLabelLanding() {
  const { brand } = useBrand();
  const config = brand?.config || {};
  const name = config.company_name || brand?.subdomain || "Portal";

  return <BrandLandingPresentation config={config} fallbackName={name} />;
}
